import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import * as dayjs from 'dayjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DaterangepickerDirective, LocaleConfig } from 'ngx-daterangepicker-material';
import { LocaleConfigDate, rangesDate, rangesDateDashboard } from 'src/app/constants/date-config.const';
import { HISTORY_QRIS, PAYMENT_UPDATE_QRIS } from 'src/app/constants/endpoint.const';
import { DashboardSelectedDate, DashboardRanges, DashboardFilter, DateRangeChangeEvent, RangesDate } from 'src/app/models/dashboard.model';
import { BaseService } from 'src/app/services/base.service';
import { HistoryQrisResponseItem, PaginationResponse } from 'src/app/types/response/qrisly.response.type';
import { ModalDownloadQrisComponent } from '../modal-download-qris/modal-download-qris.component';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  standalone: false,
  selector: 'app-table-history-qris',
  templateUrl: './table-history-qris.component.html',
  styleUrl: './table-history-qris.component.scss'
})
export class TableHistoryQrisComponent {
@ViewChild(DaterangepickerDirective, { static: false })
  datePicker!: DaterangepickerDirective;
  loading: boolean = true;
  startDate: string = '';
  endDate: string = '';
  setlocale: LocaleConfig = LocaleConfigDate;
  keepCalendarOpeningWithRange: boolean;
  selected: DashboardSelectedDate = {
    startDate: moment(),
    endDate: moment(),
  };
  ranges: any = rangesDate;
  invalidDates: moment.Moment[] = [
    moment().add(2, 'days'),
    moment().add(3, 'days'),
    moment().add(5, 'days'),
    ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  };

  @Input() filter: DashboardFilter = {
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
  };

  @Output() filterResult = new EventEmitter<DashboardFilter>();

  listOfData: HistoryQrisResponseItem[] = [];
  pagination: PaginationResponse = {
    current_page: 1,
    total_pages: 1,
    total_count: 0,
  };

  filterList = {
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    offset: 0,
    limit: 20,
  };

  isDisPrev: boolean = true;
  isDisNext: boolean = true;

  isVisibleConfirmPayment: boolean = false;
  selectedId: number = 0;

  constructor(
    public formatter: NgbDateParserFormatter,
    public baseService: BaseService,
    private message: NzMessageService,
    private modal: NzModalService,
  ) {
    this.keepCalendarOpeningWithRange = true;
  }

  ngOnInit(): void {
      this.selected = {
        startDate: moment(this.filterList.start_date, 'YYYY-MM-DD'),
        endDate: moment(this.filterList.end_date, 'YYYY-MM-DD'),
      };

      this.getHistoryQris();
    }

  onChangeDate(e: DateRangeChangeEvent | null) {
    if (!e?.startDate || !e?.endDate) return;

    this.selected = {
      startDate: moment.isMoment(e.startDate) ? e.startDate : moment(e.startDate.valueOf()),
      endDate: moment.isMoment(e.endDate) ? e.endDate : moment(e.endDate.valueOf())
    };

    this.filterList.start_date = this.selected.startDate.format('YYYY-MM-DD');
    this.filterList.end_date = this.selected.endDate.format('YYYY-MM-DD');

    this.filterResult.emit(this.filterList);
    this.getHistoryQris();
}

  getListPage(event: Event) {
    const target = event.target as HTMLInputElement;
    const perPage = Number(target.value);
    this.filterList.limit = perPage;
    this.filterList.offset = 0;
    this.getHistoryQris();
  }

  onPageChange(event: number) {
    this.filterList.offset = (event - 1) * this.filterList.limit;
    this.getHistoryQris();
  }

  onPerPageChange(event: number) {
    this.filterList.limit = event;
    this.filterList.offset = 0;
    this.getHistoryQris();
  }

  getHistoryQris() {
    this.loading = true;
    this.baseService.getData(HISTORY_QRIS, this.filterList).subscribe({
      next: (res: { data: { list: HistoryQrisResponseItem[]; pagination: PaginationResponse } }) => {
        this.listOfData = res.data.list;
        this.pagination = res.data.pagination;
        this.loading = false;
      },
      error: (err) => {
        this.message.error(err.error.meta.message);
        this.loading = false;
      },
    });
  }

  viewDetail(data: HistoryQrisResponseItem) {
    this.modal.create({
      nzTitle: undefined,
      nzContent: ModalDownloadQrisComponent,
      nzFooter: null,
      nzCentered: true,
      nzWidth: 500,
      nzData: {
        data: data
      },
      nzClosable: false,
    });
  }

  showConfirmPayment(data: HistoryQrisResponseItem) {
    this.selectedId = data.history_id;
    this.isVisibleConfirmPayment = true;
  }

  markAsPaid() {
    const payload = {
      history_id: this.selectedId,
      status: 'completed',
    };
    this.baseService.putData(PAYMENT_UPDATE_QRIS, payload).subscribe({
      next: () => {
        this.message.success('Payment updated successfully');
        this.isVisibleConfirmPayment = false;
        this.getHistoryQris();
      },
      error: () => {
        this.message.error('Failed to update payment');
      },
    });
  }

  getClassStatus(status: string): string {
    switch (status) {
      case 'paid':
        return 'paid';
      case 'unpaid':
        return 'unpaid';
      case 'expired':
        return 'expired';
      default:
        return 'unpaid';
    }
  }
}
